import { fetcher } from '@commenda/utils';

export const getSignedUrlForGet = async (
  fileId: number,
  nextAuthToken?: string
): Promise<{ signedUrl: string } | null> => {
  try {
    const res = await fetcher(
      `s3/signedUrlForGet?fileId=${fileId}`,
      {
        method: 'GET',
      },
      nextAuthToken || undefined
    );

    if (!res.ok) return null;

    const data = await res.text();

    return {
      signedUrl: data,
    };
  } catch (err) {
    console.error(err);
    return null;
  }
};
